import React, { useContext, useState, useEffect } from 'react';
import styled from 'styled-components';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import OrderController from '../../controller/OrderController';
import DeliveryConfirmModal from './DelivertConfirmModal';

let oTimeout: any;
const refreshTimer = 30 * 1000;

export type orderType = {
  order_id: string;
  bill_number: string;
  hotel_name: string;
  order_seq: number;
  created_at: string;
  delivery_address_detail: string;
  store_name: string;
  total_amount_incl: number;
  detail: string;
  active?: boolean;
};

const DeliveryConfirmList = () => {
  const [visibleConfirm, setVisibleConfirm] = useState<boolean>(false);
  const [sHotelName, set_sHotelName] = useState<string>('');
  const [orderData, set_orderData] = useState<orderType[]>([]);

  const [orderDetail, setOrderDetail] = useState<orderType>();

  let oParams = useParams();
  const getHotelOrderNotCom = async () => {
    if (oParams && oParams.hotel_id) {
      const oOrderData = await OrderController.getHotelOrderNotCom({
        hotel_id: parseInt(oParams.hotel_id),
      });

      if (oOrderData && oOrderData.store) {
        set_sHotelName(oOrderData.store.store_name);
        set_orderData(oOrderData.data);
      }
    }
  };

  const openConfirmModal = (item: orderType) => {
    setOrderDetail(item);
    setVisibleConfirm(true);
  };

  const refreshList = () => {
    clearTimeout(oTimeout);
    oTimeout = setTimeout(() => {
      getHotelOrderNotCom();
      refreshList();
    }, refreshTimer);
  };

  useEffect(() => {
    if (!sHotelName) {
      getHotelOrderNotCom();
      oTimeout = setTimeout(() => {
        getHotelOrderNotCom();
        refreshList();
      }, refreshTimer);
    }
  }, []);

  return (
    <>
      <Style>
        <div className="content">
          <h1>{sHotelName}</h1>
          <div>
            {orderData.length > 0 &&
              orderData.map((item, index: number) => (
                <div className="listItem" key={index}>
                  <div className="listName">
                    <h2>{item.delivery_address_detail}</h2>
                  </div>
                  <div className="listContent">
                    <div className="contentItem">
                      <h3>{item.store_name}</h3>
                      <h3>{item.total_amount_incl.toLocaleString()}원</h3>
                    </div>
                    <button
                      className={`successButton ${item.active === true ? 'actice' : 'unActive'}`}
                      onClick={() => {
                        if (item.active === true) openConfirmModal(item);
                      }}>
                      <h2>배달완료</h2>
                    </button>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </Style>
      <DeliveryConfirmModal
        isVisible={visibleConfirm}
        setVisible={setVisibleConfirm}
        orderDetail={orderDetail}
        getHotelOrderNotCom={getHotelOrderNotCom}
      />
    </>
  );
};
export default DeliveryConfirmList;

export const Style = styled.div`
  .content {
    position: relative;
    width: 100%;
    height: 100%;
    min-height: 100dvh;
    text-align: left;
    padding: 40px 20px;
    background: #000;
    white-space: pre-line;
  }

  h1 {
    color: #fff;
    font-weight: 500;
    text-align: center;
    margin-top: 3%;
    margin-bottom: 7%;
  }
  h3 {
    font-size: 20px;
    line-height: 36px;
    color: #ffffff;
    font-weight: 500;
  }

  .listItem {
    display: flex;
    border-radius: 10px;
    border: 2px solid #555555;
    margin: 12px 0;
    min-height: 140px;
    .listName {
      width: 30%;
      display: flex;
      flex-direction: column;
      border-right: 1px solid #555555;
      text-align: center;
      justify-content: center;
      h2 {
        color: #4dd2ae;
      }
    }
    .listContent {
      flex: 1;
      padding: 10px 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      h3 {
        width: 50%;
        word-break: break-all;
      }
      .contentItem {
        display: flex;
        width: 100%;
      }
    }

    .successButton {
      width: 30%;
      height: 100%;
      border-radius: 10px;
      background: #4dd2ae;
      border: 2px solid #4dd2ae;
      h2 {
        color: #ffffff;
        font-weight: 600;
      }
    }
    .successButton.unActive {
      background: gray;
      border: gray;
      h2 {
        color: #aaa;
      }
    }
    button.blink {
      background: #000000;
      h2 {
        color: #4dd2ae;
      }
    }
  }

  @media (max-width: 600px) {
    h1 {
      font-size: 24px;
    }
    h2 {
      font-size: 20px;
    }
    h3 {
      font-size: 14px;
      line-height: 20px;
      padding: 5px 0;
    }
    .listItem {
      .listName {
        width: 24%;
      }
      .listContent {
        h3 {
          width: 100%;
          font-weight: 600;
        }
        .contentItem {
          flex-direction: column;
        }
      }

      button {
        padding: 10px;
        width: 70%;
        height: 70%;
      }
    }
  }
`;
